import type { IEsito} from "@/app/Comms";
import {Comms} from "@/app/Comms";
import {Model} from "@/app/Model";
import {Utils} from "@/app/Utils";
import {ItemFamiglia} from "@/app/data/FamigliaAdmin";
import {CommsFamiglia} from "../CommsFamiglia";

export class FamigliaAdminComms {

    public commsFamiglia: CommsFamiglia | undefined = undefined;

    protected static instance: FamigliaAdminComms;

    protected constructor() {
        //keep it protected to help with the singleton instance
    }

    public inChiamataFamigliaList: boolean = false;
    public inChiamataFamigliaSave: boolean = false;

    public static getInstance(): FamigliaAdminComms {
        if (!FamigliaAdminComms.instance) {
            FamigliaAdminComms.instance = new FamigliaAdminComms();
        }
        return FamigliaAdminComms.instance;
    }

    public chiamataFamigliaList(callback: Function | null = null, soloPaginazione:boolean = false): void {
        if (this.commsFamiglia) {
            if (Comms.hf_isNotLogged()) {
                if (this.commsFamiglia.continueFunction) this.commsFamiglia.continueFunction = this.chiamataFamigliaList;

                setTimeout(function () {
                    Comms.getInstance().doLoginByToken(callback);
                }, Comms.baseLoadTimeout);

                return;
            } else {
                this.commsFamiglia.continueFunction = null;
            }

            let model: Model = Model.getReactiveInstance();

            if (!this.inChiamataFamigliaList) {
                this.inChiamataFamigliaList = true;

                model.fam_admin.listaFamiglia = [];

                let commander: string = "chiamataFamigliaList";
                let endpoint: string = "/graphql";
                let filters: string = '';
                let someFilters: string = '';

                //filtri da model.fam_admin.filtriFamiglia
                if (model.fam_admin.filtriFamiglia.id_doc_master != "") {
                    someFilters += ` { field: "id_doc_master", condition: "=", value: "${model.fam_admin.filtriFamiglia.id_doc_master}" }
                    `;
                }
                if (model.fam_admin.filtriFamiglia.oggetto_di_giudizio != "") {
                    someFilters += ` { field: "oggetto_di_giudizio", condition: "=", value: "${model.fam_admin.filtriFamiglia.oggetto_di_giudizio}" }
                    `;
                }
                if (model.fam_admin.filtriFamiglia.modifica_manuale != "") {
                    someFilters += ` { field: "modifica_manuale", condition: "=", value: "${model.fam_admin.filtriFamiglia.modifica_manuale}" }
                    `;
                }

                if (someFilters != '') {
                    filters = `where: {
                        must: [
                            ${someFilters}
                        ]
                    }`;
                }
                let payload = {
                    query: `{
                    msFamigliaQuery(
                        order: [{ field: "${model.fam_admin.filtriFamiglia.sort_field}", order: ${model.fam_admin.filtriFamiglia.sort_order} }]
                        ${filters}
                        select: ["*"]
                        paging: {offset: ${model.fam_admin.paginazioneFamiglia_start * model.fam_admin.paginazioneFamiglia_rows}, limit:${model.fam_admin.paginazioneFamiglia_rows}}
                    ) {
                        list
                        count
                        raw
                    }
                }`,
                    variables: {},
                    operationName: null,
                };

                let options = {
                    method: "POST",
                    headers: {
                        accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                };

                //@ts-ignore
                if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

                let errorCallback: Function = (): void => {
                    this.inChiamataFamigliaList = false;
                };

                let innerCallback: Function = (esito: IEsito): void => {
                    Utils.successAlert(esito);

                    this.inChiamataFamigliaList = false;

                    if (esito.response && esito.response.data && esito.response.data.msFamigliaQuery && esito.response.data.msFamigliaQuery.list) {
                        esito.response.data.msFamigliaQuery.list.forEach((x: any) => model.fam_admin.listaFamiglia.push(this.prepareItemFromLoad(x)));

                        model.fam_admin.paginazioneFamiglia_tot = esito.response.data.msFamigliaQuery.count;
                        model.fam_admin.paginazioneFamiglia_pages = Math.ceil(model.fam_admin.paginazioneFamiglia_tot / model.fam_admin.paginazioneFamiglia_rows) -1;

                        if (model.fam_admin.paginazioneFamiglia_start > model.fam_admin.paginazioneFamiglia_pages) {
                            model.fam_admin.paginazioneFamiglia_start = model.fam_admin.paginazioneFamiglia_pages;
                        }

                        if (!soloPaginazione) {
                            model.fam_admin.paginazioneFamiglia_start = 0;
                        }
                    }

                    if (callback) callback(esito);
                };

                this.commsFamiglia.comms.doFetch(endpoint, options, commander, innerCallback, errorCallback);
            }
        }
    }

    public chiamataFamigliaSave(callback: Function | null = null): void {
        let model: Model = Model.getReactiveInstance();

        if (this.commsFamiglia &&  model.fam_admin.itemFamiglia.id_doc_master != undefined && model.fam_admin.itemFamiglia.id_doc_master > 0) {
            if (Comms.hf_isNotLogged()) {
                if (this.commsFamiglia.continueFunction) this.commsFamiglia.continueFunction = this.chiamataFamigliaSave;

                setTimeout(function () {
                    Comms.getInstance().doLoginByToken(callback);
                }, Comms.baseLoadTimeout);

                return;
            } else {
                this.commsFamiglia.continueFunction = null;
            }

            if (!this.inChiamataFamigliaSave) {
                this.inChiamataFamigliaSave = true;

                let commander: string = "chiamataFamigliaSave";
                let endpoint: string = "/graphql";
                let itemToSend : any = this.prepareItemForSave(model.fam_admin.itemFamiglia);

                let payload = {
                    query: `mutation {
                        msFamigliaUpdate(
                            input: ${JSON.stringify(itemToSend).replace(/"([^"]+)":/g, "$1:")}
                        )
                    }
                    `,
                    variables: {},
                    operationName: null,
                };

                let options = {
                    method: "POST",
                    headers: {
                        accept: "application/json",
                        "Content-Type": "application/json",
                    },
                    body: JSON.stringify(payload),
                };

                //@ts-ignore
                if (Comms.baseUrl == "") options.headers["x-user"] = model.user.jwt;

                let errorCallback: Function = (): void => {
                    this.inChiamataFamigliaSave = false;
                };

                let innerCallback: Function = (esito: IEsito): void => {
                    Utils.successAlert(esito);

                    this.inChiamataFamigliaSave = false;

                    if (esito.response && esito.response.data && esito.response.data.msFamigliaUpdate) {
                        model.fam_admin.itemFamiglia = this.prepareItemFromLoad(esito.response.data.msFamigliaUpdate);
                    }

                    CommsFamiglia.getInstance().famigliaAdmin.chiamataFamigliaList((e: IEsito) => { }, false);

                    if (callback) callback(esito);
                };

                this.commsFamiglia.comms.doFetch(endpoint, options, commander, innerCallback, errorCallback);
            }
        }
    }

    public prepareItemForSave(item: ItemFamiglia) : any {
        let clone: any = JSON.parse(JSON.stringify(item));
        delete clone.raw;
        return clone;
    }
    
    public prepareItemFromLoad(item: ItemFamiglia) : any {
        let fieldsArrayToCheck: string[] = [
            "riferimento_normativo", "motivi_addebito_separazione", "giudice"
        ]
        fieldsArrayToCheck.forEach((field: string): void => {
            //@ts-ignore
            if (item[field] == undefined || item[field] == null) { item[field] = []; }
        });
        let clone: any = JSON.parse(JSON.stringify(item));
        item.raw = clone;
        return item;
    }
}